import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { useField } from 'vee-validate';
import AdditionalDiseasesDescriptionField from './AdditionalDiseasesDescriptionField.vue';
import HasCareField from './HasCareField.vue';


export default {
  __name: 'AdditionalDiseasesField',
  props: {
    isExtended: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default:
            'Czy choruje Pani na choroby przewIekłe lub posiada alergie/uczulenie na jakiekolwiek Ieki?',
    },
    isRequired: {
        type: Boolean,
        default: true,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const { value, errorMessage } = useField('additionalDiseases');

const __returned__ = { props, value, errorMessage, get RadioGroup() { return RadioGroup }, get RadioGroupOption() { return RadioGroupOption }, get useField() { return useField }, AdditionalDiseasesDescriptionField, HasCareField }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}